import { useEffect, useState } from 'react';

const SBC_CONFIG_CHECK_LOOP_MS = 500;

/**
 * This hook will watch for the global __sbc_config object and return it when it is defined.
 * The config is loaded asynchronously via a small bit of inline JS in index.html. It would be
 * better to have the config defined in index.html and load it synchronously, but we cannot
 * currently create environment-specific configs at build time.
 */
export const useSbcConfig = () => {
  const [config, setConfig] = useState<typeof window.__sbc_config>(window.__sbc_config);

  // Watch for SBC config being loaded
  useEffect(() => {
    if (!config) {
      const loop = window.setInterval(() => {
        setConfig(window.__sbc_config);
      }, SBC_CONFIG_CHECK_LOOP_MS);
      return () => {
        window.clearInterval(loop);
      };
    }
  }, [config]);

  return {
    config,
    isLoading: !config
  };
};
